export default __webpack_public_path__ + "static/day-3-3aadaa6cce0129f54389fe9278e81ad5.gif";